export default {"src":"/_next/static/media/arrow-right-from-bracket-solid.cbc3c8dd.svg","height":512,"width":512};